import type * as SchemaTypes from '../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitOrganisationalAiReadinessAssessmentResultMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitOrganisationalAiReadinessAssessmentResultInput;
}>;


export type SubmitOrganisationalAiReadinessAssessmentResultMutation = (
  { __typename: 'Mutation' }
  & { submitOrganisationalAiReadinessAssessmentResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'SubmitOrganisationalAiReadinessAssessmentResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'AssessmentResult' }
      & OrganisationalAiReadinessAssessmentResultFragment
    )> }
  ) }
);

export type OrganisationalAiReadinessAssessmentResultFragment = (
  { __typename: 'AssessmentResult' }
  & Pick<SchemaTypes.AssessmentResult, 'id'>
  & { result: { __typename: 'AitResult' } | { __typename: 'CardioRespResult' } | { __typename: 'DigitSpanResult' } | { __typename: 'GrowthMindsetResult' } | { __typename: 'InbodyCompositionResult' } | { __typename: 'IndividualMotivationResult' } | { __typename: 'ML360Result' } | { __typename: 'NBackResult' } | (
    { __typename: 'OrganisationalAiReadinessResult' }
    & OrganisationalAiReadinessResultDataFragment
  ) | { __typename: 'PersonalCopingResult' } | { __typename: 'ProcessingSpeedResult' } | { __typename: 'SartResult' } | { __typename: 'SelfDeterminationResult' } | { __typename: 'SpatialPlanningResult' } | { __typename: 'StrengthResult' } | { __typename: 'TeamResilienceResult' } | { __typename: 'TrainersNotesResult' } | { __typename: 'VisualReactionResult' } }
);

export type OrganisationalAiReadinessResultDataFragment = (
  { __typename: 'OrganisationalAiReadinessResult' }
  & { categoryAverages: Array<(
    { __typename: 'OrganisationalAiReadinessCategoryAverage' }
    & Pick<SchemaTypes.OrganisationalAiReadinessCategoryAverage, 'category' | 'maximumPossibleScore' | 'averageScore' | 'label' | 'description'>
  )>, overallScore: (
    { __typename: 'OrganisationalAiReadinessOverallScore' }
    & Pick<SchemaTypes.OrganisationalAiReadinessOverallScore, 'score' | 'maximumPossibleScore' | 'label'>
  ) }
);

export const OrganisationalAiReadinessResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment OrganisationalAiReadinessResultData on OrganisationalAiReadinessResult {
  categoryAverages {
    category
    maximumPossibleScore
    averageScore
    label
    description
  }
  overallScore {
    score
    maximumPossibleScore
    label
  }
}
    `;
export const OrganisationalAiReadinessAssessmentResultFragmentDoc = /*#__PURE__*/ gql`
    fragment OrganisationalAiReadinessAssessmentResult on AssessmentResult {
  id
  result {
    __typename
    ... on OrganisationalAiReadinessResult {
      ...OrganisationalAiReadinessResultData
    }
  }
}
    ${OrganisationalAiReadinessResultDataFragmentDoc}`;
export const SubmitOrganisationalAiReadinessAssessmentResultDocument = /*#__PURE__*/ gql`
    mutation SubmitOrganisationalAiReadinessAssessmentResult($input: SubmitOrganisationalAiReadinessAssessmentResultInput!) {
  submitOrganisationalAiReadinessAssessmentResult(input: $input) {
    ... on SubmitOrganisationalAiReadinessAssessmentResultSuccessfulResponse {
      result {
        ...OrganisationalAiReadinessAssessmentResult
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${OrganisationalAiReadinessAssessmentResultFragmentDoc}`;
export type SubmitOrganisationalAiReadinessAssessmentResultMutationFn = Apollo.MutationFunction<SubmitOrganisationalAiReadinessAssessmentResultMutation, SubmitOrganisationalAiReadinessAssessmentResultMutationVariables>;

/**
 * __useSubmitOrganisationalAiReadinessAssessmentResultMutation__
 *
 * To run a mutation, you first call `useSubmitOrganisationalAiReadinessAssessmentResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitOrganisationalAiReadinessAssessmentResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitOrganisationalAiReadinessAssessmentResultMutation, { data, loading, error }] = useSubmitOrganisationalAiReadinessAssessmentResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitOrganisationalAiReadinessAssessmentResultMutation(baseOptions?: Apollo.MutationHookOptions<SubmitOrganisationalAiReadinessAssessmentResultMutation, SubmitOrganisationalAiReadinessAssessmentResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitOrganisationalAiReadinessAssessmentResultMutation, SubmitOrganisationalAiReadinessAssessmentResultMutationVariables>(SubmitOrganisationalAiReadinessAssessmentResultDocument, options);
      }
export type SubmitOrganisationalAiReadinessAssessmentResultMutationHookResult = ReturnType<typeof useSubmitOrganisationalAiReadinessAssessmentResultMutation>;
export type SubmitOrganisationalAiReadinessAssessmentResultMutationResult = Apollo.MutationResult<SubmitOrganisationalAiReadinessAssessmentResultMutation>;
export type SubmitOrganisationalAiReadinessAssessmentResultMutationOptions = Apollo.BaseMutationOptions<SubmitOrganisationalAiReadinessAssessmentResultMutation, SubmitOrganisationalAiReadinessAssessmentResultMutationVariables>;